class ProductDetailActions extends Component {
    constructor(el) {
        super(el);

        this.linkButtonExternal = this.$find('[data-button-external]');
        this.buttonInquiry = this.$find('[data-button-inquiry]');

        this.inquiryUrl = this.$el.dataset.urlInquiry;

        EventBus.getInstance().addEventListener('productVariantChanged', e => this.onVariantChange(e.detail));
        EventBus.getInstance().addEventListener('productDetailActionSubmit', () => this.showInquiry());
        EventBus.getInstance().addEventListener('inquiryFormSent', () => this.onInquiryFormSent());
        EventBus.getInstance().addEventListener('inquiryFormReloaded', () => this.loadInquiryFormFrame());
        this.buttonInquiry.addEventListener('click', () => this.showInquiry());

        this.linkButtonExternal.classList.add('u-hidden'); // ve výchozím stavu neviditelné, dokud není vybrána varianta s konkrétní cenou
        this.buttonInquiry.disabled = true; // ve výchozím stavu zakázáno, dokud není vybrána varianta
        if (window.variantData.length === 1) {
            this.onVariantChange(window.variantData[0]);
        }
    }

    onVariantChange(variant) {
        this.variantId = variant.id;
        this.linkButtonExternal.href = variant.externalUrl;
        this.loadInquiryFormFrame();

        this.buttonInquiry.classList.remove('u-hidden'); // tlačítko poptání má být vždy viditelné
        this.buttonInquiry.disabled = false; // Při přepnutí varianty opět povolit tlačítko Poptat
        EventBus.getInstance().dispatchEvent('productDetailActionButtonChanged', {button: this.buttonInquiry}); // poptávka bude vždy výchozí akce

        if (variant.externalUrl) {
            this.linkButtonExternal.classList.remove('u-hidden');
        } else {
            this.linkButtonExternal.classList.add('u-hidden');
        }
    }

    onInquiryFormSent() {
        this.buttonInquiry.disabled = true;
    }

    loadInquiryFormFrame() {
        this.formFrame = document.querySelector('[data-inquiry-form-frame]');
    }

    showInquiry() {
        this.formFrame && this.formFrame.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });
    }
}
